import { UserManager, WebStorageStateStore } from 'oidc-client';
import userManagerConfig from './config';

// use for development only, need to add Log as import from oidc-client
// Log.logger = console;
// Log.level = Log.DEBUG;

const AuthUserManager = new UserManager({
  ...userManagerConfig,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
});

AuthUserManager.events.addUserLoaded(() => {
  const initialRequestUri = localStorage.getItem('initialRequestUri');
  if (window.location.href.includes('auth-callback')) {
    window.location.replace(initialRequestUri);
  }
});

export const handleError = error => {
  // eslint-disable-next-line no-console
  console.error('Problem with authentication endpoint: ', error);
};

export const logout = () => {
  try {
    window.history.replaceState(null, '', '/');
    AuthUserManager.signoutRedirect();
  } catch (error) {
    handleError(error);
  }
};

AuthUserManager.events.addAccessTokenExpired(() => logout());

export const getUser = async () => {
  const user = await AuthUserManager.getUser();

  if (!user) {
    return AuthUserManager.signinRedirectCallback();
  }

  return user;
};

export const signinRedirectCallback = async () => {
  await AuthUserManager.signinRedirectCallback();
};

export const signinRedirect = () => {
  AuthUserManager.clearStaleState();
  localStorage.setItem('initialRequestUri', window.location.pathname);
  AuthUserManager.signinRedirect({});
};

export const signinSilentCallback = async () => {
  await AuthUserManager.signinSilentCallback();
};

export const isAuthenticated = () => {
  const oidcStorage = JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`
    )
  );
  return !!oidcStorage && !!oidcStorage.access_token ? oidcStorage : {};
};
